import { Badge, Card } from '@catering/ui';
import { AlertTriangle } from 'lucide-react';
import type { JSX } from 'react';

import type { ProductionLine } from '../../../production/api';
import type { CatalogNameMap } from '../../../production/use-catalog-names';
import { ProductionLineTable } from './production-line-table';

export interface DietaryHighlightBlockProps {
  lines: ProductionLine[];
  /** `false` for print: every breakdown shows expanded, no chevrons to click on paper. */
  expandable?: boolean;
  serviceTypeNames?: CatalogNameMap;
  dietaryTagNames?: CatalogNameMap;
}

/**
 * `production-sheets/spec.md` → "Menú SIN_TACC aparece en bloque
 * separado": visually distinct block (amber border/background, not just
 * text) for `splitByDietaryCriticality(...).critical`, shared by
 * `ProductionSheetViewPage` and `ProductionSheetPrintPage` — never a
 * second copy of the byCustomerSite rendering logic.
 */
export function DietaryHighlightBlock({
  lines,
  expandable = true,
  serviceTypeNames = {},
  dietaryTagNames = {},
}: DietaryHighlightBlockProps): JSX.Element | null {
  if (lines.length === 0) {
    return null;
  }

  return (
    <Card
      data-testid="dietary-highlight-block"
      variant="outlined"
      className="border-2 border-amber-300 bg-amber-50/60"
    >
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle aria-hidden="true" className="size-5 text-amber-600" />
        <h2 className="text-base font-semibold text-amber-900">
          Atención: menús con restricción dietaria
        </h2>
        <Badge variant="warning">{lines.length}</Badge>
      </div>

      <ProductionLineTable
        lines={lines}
        expandable={expandable}
        serviceTypeNames={serviceTypeNames}
        dietaryTagNames={dietaryTagNames}
      />
    </Card>
  );
}
